import { render, staticRenderFns } from "./DeliveryApproval.vue?vue&type=template&id=7bfa6afa&scoped=true&"
import script from "./DeliveryApproval.vue?vue&type=script&lang=js&"
export * from "./DeliveryApproval.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryApproval.vue?vue&type=style&index=0&id=7bfa6afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa6afa",
  null
  
)

export default component.exports